import React from 'react';
import { ShieldAlert, Key, Smartphone, Lock } from 'lucide-react';

const Security = ({ userData }: { userData?: any }) => {
  if (!userData) return null;

  return (
    <div className="max-w-4xl mx-auto space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-white">Security Settings</h1>
        <p className="text-gray-400 mt-1">Keep your account safe and manage connected devices.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        
        {/* Credentials Card (Read Only) */}
        <div className="bg-[#131b2c] border border-gray-800 rounded-2xl p-6 shadow-xl flex flex-col justify-center items-center text-center">
          <div className="w-16 h-16 bg-blue-500/10 rounded-full flex items-center justify-center mb-4">
            <Lock className="text-blue-500" size={32} />
          </div>
          <h3 className="text-xl font-bold text-white mb-2">Account Credentials</h3>
          <p className="text-sm text-gray-400 mb-6">
            For security reasons, password modification is restricted on the customer portal. 
            All credential updates are managed centrally.
          </p>
          <div className="bg-[#0b1221] border border-gray-800 rounded-xl p-4 w-full">
            <p className="text-xs text-gray-500 uppercase tracking-widest mb-1">Your Login ID</p>
            <p className="text-lg font-bold text-white font-mono">{userData.login_id}</p>
          </div>
          <p className="text-xs text-gray-500 mt-4">Please contact your account manager or admin to request a password reset.</p>
        </div>

        <div className="space-y-6">
          {/* 2FA Card */}
          <div className="bg-[#131b2c] border border-gray-800 rounded-2xl p-6 shadow-xl flex items-start gap-4">
            <ShieldAlert className="text-purple-500 shrink-0" size={28} />
            <div>
              <h3 className="text-lg font-bold text-white mb-1">Two-Factor Auth (2FA)</h3>
              <p className="text-sm text-gray-400 mb-4">Add an extra layer of security to your account using an authenticator app.</p>
              <button className="bg-[#1e222d] border border-gray-700 text-white px-4 py-2 rounded-lg text-sm font-bold hover:bg-gray-800 transition-colors">Enable 2FA</button>
            </div>
          </div>

          {/* Active Sessions */}
          <div className="bg-[#131b2c] border border-gray-800 rounded-2xl p-6 shadow-xl">
            <div className="flex items-center gap-3 mb-4">
              <Smartphone className="text-gray-400" size={20} />
              <h3 className="text-white font-bold">Active Sessions</h3>
            </div>
            <div className="flex items-center justify-between p-3 bg-[#0b1221] rounded-lg border border-gray-800">
              <div>
                <p className="text-white text-sm font-bold">Windows • Chrome</p>
                <p className="text-xs text-green-500">Current Session (India)</p>
              </div>
              <button className="text-xs text-red-400 hover:underline">Log out</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Security;